var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTable',{attrs:{"title":"Aggiornamenti Ticket","headers":_vm.headers,"items":_vm.items,"total-rows":_vm.totalRows,"loading":_vm.loading,"elevation":0,"sortby":"logged_at"},on:{"refresh":_vm.onRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }